import { canUseDOM } from './canUseDOM';

export const isIE =
  canUseDOM && /*@cc_on!@*/ (false || !!document.documentMode);
